module.exports = __webpack_public_path__ + "img/531fa6820e90460b9f82e84c7f20d6e4.1f8b8b78.jpg";